/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import corporateMemberTasklistFormData from "../data/CorporateMemberTable.Data";
import FormCreator from "../../../components/Forms/FormCreator";
import { useLazyGetAllDropdownsForCorporateMemberQuery } from "../../../app/services/Corporate/CorporateTaskListApi";
import { setAllDropDownField } from "../utils/setAllDropDownField";
import PageLoader from "../../../components/ui/pageLoader/PageLoader";
import ModuleLoader from "../../../components/ui/moduleLoader/ModuleLoader";

const CorporateMemberSearchForm = forwardRef((props, ref) => {
    const searchFormRef = useRef();
    const [searchFormData, SetSearchForm] = useState(corporateMemberTasklistFormData);

    const [getAllDropDowns, {
        data: dropdownResponse,
        isSuccess: isSuccess,
        isLoading: isLoading,
    }] = useLazyGetAllDropdownsForCorporateMemberQuery();

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const searchFormResponse = searchFormRef.current.getFormData();
                return searchFormResponse;
            }
            return null;
        }
    }));

    useEffect(() => {
        if (!isLoading && isSuccess && dropdownResponse) {
            setAllDropDownField(dropdownResponse)
        }
    }, [isLoading, isSuccess, dropdownResponse])

    useEffect(() => { getAllDropDowns() }, [])

    return (isSuccess ? <FormCreator ref={searchFormRef} {...searchFormData} /> : <ModuleLoader />)

})

export default CorporateMemberSearchForm